import React from 'react';
import { Colors } from '../../constants';

const Spinner = ({ color = null }) => {
  return(
    // By Sam Herbert (@sherb), for everyone. More @ http://goo.gl/7AJzbL 
    <svg width="158" height="158" viewBox="0 0 58 58" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
          <g transform="translate(2 1)">
              <circle cx="42.601" cy="11.462" r="3" fillOpacity="1" fill={color || `#${Colors.primaryColor}`}>
                  <animate attributeName="fill-opacity"
                      begin="0s" dur="1.3s"
                      values="1;0;0;0;0;0;0;0" calcMode="linear"
                      repeatCount="indefinite" />
              </circle> { /** 1 */ }
              <circle cx="49.063" cy="27.063" r="3.5" fillOpacity="0" fill={color || `#${Colors.primaryColor}`}>
                  <animate attributeName="fill-opacity"
                      begin="0s" dur="1.3s"
                      values="0;1;0;0;0;0;0;0" calcMode="linear"
                      repeatCount="indefinite" />
              </circle> { /** 2 */ }
              <circle cx="42.601" cy="42.663" r="4" fillOpacity="0" fill={color || `#${Colors.primaryColor}`}>
                  <animate attributeName="fill-opacity"
                      begin="0s" dur="1.3s"
                      values="0;0;1;0;0;0;0;0" calcMode="linear"
                      repeatCount="indefinite" />
              </circle> { /** 3 */ }
              <circle cx="27" cy="49.125" r="4.5" fillOpacity="0" fill={color || `#${Colors.primaryColor}`}>
                  <animate attributeName="fill-opacity"
                      begin="0s" dur="1.3s"
                      values="0;0;0;1;0;0;0;0" calcMode="linear"
                      repeatCount="indefinite" />
              </circle> { /** 4 */ }
              <circle cx="11.399" cy="42.663" r="5" fillOpacity="0" fill={color || `#${Colors.primaryColor}`}>
                  <animate attributeName="fill-opacity"
                      begin="0s" dur="1.3s"
                      values="0;0;0;0;1;0;0;0" calcMode="linear"
                      repeatCount="indefinite" />
              </circle> { /** 5 */ }
              <circle cx="4.938" cy="27.063" r="4.5" fillOpacity="0" fill={color || `#${Colors.primaryColor}`}>
                  <animate attributeName="fill-opacity"
                      begin="0s" dur="1.3s"
                      values="0;0;0;0;0;1;0;0" calcMode="linear"
                      repeatCount="indefinite" />
              </circle> { /** 6 */ }
              <circle cx="11.399" cy="11.462" r="4" fillOpacity="0" fill={color || `#${Colors.primaryColor}`}>
                  <animate attributeName="fill-opacity"
                      begin="0s" dur="1.3s"
                      values="0;0;0;0;0;0;1;0" calcMode="linear"
                      repeatCount="indefinite" />
              </circle> { /** 7 */ }
              <circle cx="27" cy="5" r="3.5" fillOpacity="0" fill={color || `#${Colors.primaryColor}`}>
                  <animate attributeName="fill-opacity"
                      begin="0s" dur="1.3s"
                      values="0;0;0;0;0;0;0;1" calcMode="linear"
                      repeatCount="indefinite" />
              </circle> { /** 8 */ }
          </g>
      </g>
    </svg>
  );
};

export default Spinner;